import React from "react";
import { ReactComponent as EyeRefreshIcon } from "../../assets/icons/eye-refresh.svg";
import { useCustomTranslation } from "@/hooks/useTranslation";
import { useGlobalStore } from "@/store";
import { FETreatmentGeneration } from "./Mesh";
import { save3DStepAttachments } from "./teethControls/addRemoveAttachment";
import { customTeethGizmoControls } from "./Camera";

let isResetDone = false;
let isRedoDone = true;
export let hoveredStepNumber;
export const ShowOriginal = ({
  reset,
  setToggle,
  showContModification,
  show3DControls,
}) => {
  const { setStepperControls, currentStep } = useGlobalStore(state => ({
    setStepperControls: state.setStepperControls,
    currentStep: state.stepperControls.currentStep,
  }));

  const { content } = useCustomTranslation();

  const getContent = (group, key) => {
    return content(`controls.${group}.${key}`);
  };
  const handleOnMouseOver = () => {
    console.log("mouse over clicked");
    setToggle("showContModification", !showContModification);
    reset(true, true);
    hoveredStepNumber = currentStep;
    save3DStepAttachments(FETreatmentGeneration.getCurrentStep());
    FETreatmentGeneration.moveToStep(0);
    setStepperControls("currentStep", 0);
    setStepperControls("storedStep", 0);
    customTeethGizmoControls.setIsEnabled(showContModification);
    // if (!isResetDone && isRedoDone) {
    //   // reset(true);
    //   isResetDone = true;
    //   isRedoDone = false;
    // }
  };
  // const handleOnMouseOut = () => {
  //   if (isResetDone && !isRedoDone) {
  //     setStepperControls("currentStep", hoveredStepNumber);
  //     setStepperControls("storedStep", hoveredStepNumber);
  //     // showOriginalRemovedHover();
  //     isResetDone = false;
  //     isRedoDone = true;
  //   } else {
  //     setTimeout(() => {
  //       handleOnMouseOut;
  //     }, 1000);
  //   }
  // };

  return (
    <button
      className="mb-2 grid w-[258px] grid-cols-[1fr,auto] bg-white px-4 py-4"
      onClick={handleOnMouseOver}
      // onMouseLeave={handleOnMouseOut}
    >
      <div className="text-start text-base font-medium">
        {getContent("actions", "show_initial")}{" "}
      </div>
      <EyeRefreshIcon />
    </button>
  );
};
